var table = (function($) {
	'use strict';

	var _toggle = function() {
		var tableFor = 'marketers';
		var tableFrequency = 'monthly';

		$('[data-tab]').on('click', function() {
			var thisTab = $(this).data('tab');
			tableFor = thisTab;

			$('.table__tabs__tab').removeClass('active');
			$(this).addClass('active');

			$('[data-for]').hide();
			$('[data-frequency="' + tableFrequency + '"][data-for="' + thisTab + '"]').show();

			$('[data-cta-for]').hide();
			$('[data-cta-for="' + thisTab + '"]').show();
		});

		$('.switch input').on('change', function() {
			var state = $('.switch input').is(':checked');
            $('.switch--label').removeClass('active');
            $('.tooltip').removeClass('active');
			if (state) {
				tableFrequency = 'annually';
				$('[data-for="' + tableFor + '"][data-frequency="monthly"]').hide();
				$('[data-for="' + tableFor + '"][data-frequency="annually"]').show();
                $('.switch--label_annual').addClass('active');
			} else {
				tableFrequency = 'monthly';
				$('[data-for="' + tableFor + '"][data-frequency="annually"]').hide();
				$('[data-for="' + tableFor + '"][data-frequency="monthly"]').show();
                $('.switch--label_monthly').addClass('active');
			}
		});
	};

	var _tooltips = function() {
		$('.js-trigger-tooltip').on('mouseenter touchstart', function(event) {
			event.preventDefault();

			if ($(this).find('.tooltip').hasClass('active')) {
				$(this).find('.tooltip').removeClass('active');
			} else {
				$('.tooltip').removeClass('active');
				$(this).find('.tooltip').addClass('active');
			}
		});
		$('.js-trigger-tooltip').on('mouseleave', function(event) {
			event.preventDefault();

			$('.tooltip').removeClass('active');
			$(this).find('.tooltip').removeClass('active');
	
		});

		$('body').on('click', '.tooltip', function(event) {
			event.preventDefault();
			$(this).removeClass('active');
		});
	};

	var _mobile = function(val) {
		var current = -100;

		$('.js-package-next').on('click', function(event) {
			current = current - 100;
			$('.table-mobile__package').css('transform', 'translate('+current+'%)');
		});

		$('.js-package-prev').on('click', function(event) {
			current = current + 100;
			$('.table-mobile__package').css('transform', 'translate('+current+'%)');
		});

		$('.switch input[type="checkbox"]').on('touchstart mousedown', function() {
			$('.switch input[type="checkbox"]').prop("checked", !$('.switch input[type="checkbox"]').prop("checked"));
		});
	};

	function init() {
		_toggle();
		_tooltips();
		_mobile();
	}

	return {
		init:init
	};
}(jQuery));

jQuery(document).ready(function($) {
	table.init();
});
